export const BIGQUERY_TOOL_CALL_NAME = 'ask_ai_bigquery' as const;
